export class RespCenter {
    constructor(DEPARTMENT_ID?: string, DESCR?: string) {
        this.DEPARTMENT_ID = DEPARTMENT_ID;
        this.DESCR = DESCR;
    }
    DEPARTMENT_ID: string;
    DESCR: string;
}